import { render, staticRenderFns } from "./ManageHelp.vue?vue&type=template&id=08d07aba&"
import script from "./ManageHelp.vue?vue&type=script&lang=js&"
export * from "./ManageHelp.vue?vue&type=script&lang=js&"
import style0 from "./ManageHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports